import { withResult } from 'feathers-fletching';
import { withSearch } from 'src/feathers/hooks';
import { validateSchema } from 'straightline-utils/hooks';

const withSearches = withSearch({
  name: withSearch.string,
  description: withSearch.text,
  'address.name': withSearch.string,
  'address.city': withSearch.string,
  'address.address_1': withSearch.text,
  'address.postal_code': withSearch.number
});

const withResults = withResult({
  address: (result) => {
    if (result.address) {
      return {
        ...result.address,
        position: {
          lat: Number(result.address.latitude),
          lng: Number(result.address.longitude)
        }
      };
    }
  },
  totals: async (result, context) => {
    if (!result.id) {
      return undefined;
    }
    if (!context.params.totals) {
      return undefined;
    }
    const addressQuery = (type, result) => {
      return {
        [`${type}.address_1`]: result.address.address_1,
        [`${type}.address_2`]: result.address.address_2,
        [`${type}.city`]: result.address.city,
        [`${type}.state`]: result.address.state,
        [`${type}.postal_code`]: result.address.postal_code,
        [`${type}.country`]: result.address.country,
        $limit: 0
      };
    };
    const [shipmentPickups, shipmentDeliveries, quotePickups, quoteDeliveries] =
      await Promise.all([
        context.app.service('api/shipments').find({
          query: addressQuery('pickup_address', result)
        }),
        context.app.service('api/shipments').find({
          query: addressQuery('delivery_address', result)
        }),
        context.app.service('api/shipment-quotes').find({
          query: addressQuery('pickup_address', result)
        }),
        context.app.service('api/shipment-quotes').find({
          query: addressQuery('delivery_address', result)
        })
      ]);

    return {
      shipments: {
        pickups: shipmentPickups.total,
        deliveries: shipmentDeliveries.total
      },
      shipmentQuotes: {
        pickups: quotePickups.total,
        deliveries: quoteDeliveries.total
      }
    };
  }
});

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [validateSchema],
    update: [validateSchema],
    patch: [validateSchema],
    remove: []
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
